/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 08 2024
 **/

import { useCallback } from "react";
import { useAtomValue } from "jotai";
import { useAtomCallback } from "jotai/utils";

import { JotaiStore } from "@/frameworks/libraries/commons";

import PhoneCallAtoms from "./PhoneCallAtoms";

export default function usePhoneCallMediaState() {
	const getCallMediaState = ({ userID, callID }: { userID: string; callID: string }) => {
		const result = useAtomValue(PhoneCallAtoms.CallUsers(callID), { store: JotaiStore });
		if (result) {
			return result[userID];
		}
	};

	const getList = (callID: string) => {
		return useAtomValue(PhoneCallAtoms.CallUsers(callID));
	};

	const getUIPopupState = useAtomCallback(
		useCallback((get) => {
			return get(PhoneCallAtoms.Popup);
		}, []),
		{ store: JotaiStore }
	);

	return { getCallMediaState, getList, getUIPopupState };
}
